<ng-container *ngIf="!accountLoading && (account$ | async) as account; else contentLoading">

  <div class="flex align-items-center justify-content-between mb-2">
    <p class="mt-0 mb-0 text-sm text-600">
      The data behind each service — price, what's included, and the service's own FAQs. One edit
      here updates everywhere it shows: the service page, its Google listing title, and the home
      page cards. The page WORDING is edited in Pages.
    </p>
    <button pButton pRipple type="button" label="New service" icon="pi pi-plus"
      class="p-button-text p-button-sm flex-shrink-0 ml-3" (click)="onAdd()"></button>
  </div>

  <table class="w-full" style="border-collapse: collapse">
    <tr *ngFor="let svc of servicesAsList(account.data?.content)" class="border-bottom-1 border-100">
      <td class="py-2">
        <strong>{{ svc.name || '(unnamed)' }}</strong>
        <i *ngIf="svc.featured" class="pi pi-star ml-2 text-500" style="font-size: 0.75rem"
          pTooltip="Featured on the home page cards" tooltipPosition="top"></i>
        <div class="text-500 text-xs font-mono">{{ svc._meta.id }}</div>
      </td>
      <td class="py-2 text-600 text-sm" style="width: 8rem">{{ price(svc) }}</td>
      <td class="py-2 text-500 text-sm" style="width: 10rem">
        {{ (svc.inclusions || []).length }} inclusion(s), {{ (svc.faqs || []).length }} FAQ(s)
      </td>
      <td class="py-2 text-right" style="width: 10rem">
        <button pButton pRipple type="button" icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm"
          (click)="onEdit(svc)" title="Edit"></button>
        <button pButton pRipple type="button" icon="pi pi-cloud-upload" class="p-button-rounded p-button-text p-button-sm"
          [loading]="publishingId === svc._meta.id" [disabled]="!!publishingId"
          (click)="onPublish(svc)" title="Publish just this service's data to the website preview"></button>
        <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger p-button-sm"
          (click)="onDelete(svc)" title="Remove"></button>
      </td>
    </tr>
  </table>

  <p *ngIf="!servicesAsList(account.data?.content).length" class="text-500 text-sm mt-3">
    <span *ngIf="!loadFailed">
      None yet — the site is using its built-in service data. Run the seed script
      (seed-cms-site-services.mjs) to make it editable here.
    </span>
    <span *ngIf="loadFailed" class="app-text-overdue">
      The content couldn't be loaded — this list is empty because of an error.
    </span>
  </p>

</ng-container>

<ng-template #contentLoading>
  <div class="flex flex-column align-items-center justify-content-center p-6 text-500">
    <i class="pi pi-spin pi-spinner text-3xl mb-3" aria-hidden="true"></i>
    <span>Loading…</span>
  </div>
</ng-template>
